import { createFileRoute } from '@tanstack/react-router'
import { DeliveryOrdersPage } from '@/features/delivery-orders'

export const Route = createFileRoute('/_authenticated/delivery-orders/')({
  component: DeliveryOrdersPage,
})
